import React from 'react';

export default function Panel({ children }: { children: React.ReactNode }) {
    return (
        <div className="border border-border rounded-md shadow-md relative w-4/12 h-5/6 bg-surface">
            {children}
        </div>
    );
}
